import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import { FormikErrors, FormikTouched } from 'formik';
import { lazy } from 'react';
import * as Yup from 'yup';

import * as Interfaces from 'app/interfaces';
import { constants } from 'app/utils';

import type { FormValues } from './interfaces';

const initialValues: FormValues = {
  redeem: {
    redemptionType: ''
  }
};

const initialErrors: FormikErrors<FormValues> = {};
const initialTouched: FormikTouched<FormValues> = {};

const redeemSchema = Yup.object<FormValues['redeem']>().shape({
  redemptionType: Yup.string<Interfaces.Common.RedemptionType>().required(
    constants.GenericValidationErrors.required
  )
});

const validationSchema = Yup.object<FormValues>().shape({
  redeem: redeemSchema
});

const Component = lazy(() => import('./RedeemSelect'));

const Step: StepProps<FormValues> = {
  id: Interfaces.Common.RedeemStep.Select,
  title: constants.RedemptionPage.title,
  stepName: 'Redeem voucher',
  Component,
  validation: {
    schema: validationSchema,
    fieldNames: ['redeem.redemptionType']
  }
};

export { Step, initialErrors, initialTouched, initialValues, redeemSchema, validationSchema };
